<template>

  <b-col cols="12" sm="12">
    <b-row class="d-flex mb-1 mt-container">
      <b-col cols="12" md="auto">
        <b-btn class="d-flex align-items-center justify-content-center text-white w-100" variant="info"
          @click="toggleSidebar('A')">
          <feather type="map" class="feather-sm mr-2"></feather> {{ $t('vMonitoreo.dispositivosUbic') }}
        </b-btn>
      </b-col>
      <b-col cols="12" md="auto">
        <b-btn class="d-flex align-items-center justify-content-center text-white w-100 mt-button" variant="info"
          @click="toggleSidebar('B')">
          <feather type="bell" class="feather-sm mr-2"></feather> {{ $t('vMonitoreo.listadoAlertas') }}
        </b-btn>
      </b-col>
    </b-row>

    <!--Mapa-->
    <div class="map-wrapper-scaling">
      <mapa ref="map" :options="options" @locationMarker="handleLocationMarker" @userLocation="UpdateUserLocation"
        @mapReference="mapReference = $event" style="height: 100%; width: 100%;">
      </mapa>
    </div>

    <!-- Panel dispositivos y ubicaciones -->
    <panel-component id="sidebar-dispositivos" :visible.sync="isSidebarAVisible">
      <b-tabs v-model="tabIndex" content-class="mt-3">
        <!-- Pestaña para mostrar los dispositivos -->
        <b-tab title="Dispositivos" active>
          <div class="mb-2 d-block">
            <b-button :disabled="emptyDevices" @click="verTodosDispositivos"
              :class="banderaVerTodos ? 'mb-1 mr-2 w-100' : 'mb-2 mr-2 d-flex align-items-center justify-content-center w-100'"
              :variant="banderaVerTodos ? undefined : 'info'" style="color: white">
              {{ banderaVerTodos ? 'Ocultar dispositivos' : 'Mostrar dispositivos' }}
            </b-button>
            <b-button :disabled="emptyGeofences" @click="verGeocercas"
              :class="banderaGeocercas ? 'mb-1 mr-2 w-100' : 'mb-2 mr-2 d-flex align-items-center justify-content-center w-100'"
              :variant="banderaGeocercas ? undefined : 'info'" style="color: white">
              {{ banderaGeocercas ? $t('vMonitoreo.ocultarGeocercas') : 'Mostrar geocercas' }}
            </b-button>
          </div>
          <input-buscar class="mb-2" layout="column" :filter="filterSearch"
            @input="filterSearch = $event"></input-buscar>
          <base-table :items="dispositivosTodos" :fields="fields" :totalRows="totalRowsDevices" :filter="filterSearch"
            :perPage="9" @filtered="onFilteredDevices">
            <template #cell(nombre)="data">
              <div>{{ formatDeviceName(data.item) }}</div>
            </template>
            <template #cell(acciones)="data">
              <div class="row icons" style="padding: 0.8rem">
                <!-- Mostrar a Angelica -->
                <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                  :style="!data.item.hasPosition ? 'color: lightgray; cursor: auto;' : ''"
                  @click="data.item.hasPosition ? verDispositivo(data.item) : verDispositivo(data.item)"
                  v-b-tooltip.hover
                  :title="data.item.hasPosition ? !data.item.sim ? $t('Gral.ver') : $t('configDispositivos.ocultar') : 'El dispositivo no cuenta con posiciones registradas'">
                  <feather :type="data.item.sim ? 'eye' : 'eye'" class="feather-sm mr-2"
                    :style="isVisibleMap(data.item.sim)"></feather>
                </b-button>
                <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                  @click="editarDispositivo(data.item)" v-b-tooltip.hover :title="$t('Gral.editar')">
                  <feather type="edit" class="feather-sm mr-2"></feather>
                </b-button>
                <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                  :style="!data.item.hasGeofence ? 'color: lightgray; cursor: auto;' : ''"
                  @click="data.item.hasGeofence ? verGeocercaGps(data.item) : null" v-b-tooltip.hover
                  :title="data.item.hasGeofence ? !data.item.select ? $t('vMonitoreo.verGeocercas') : $t('vMonitoreo.ocultarGeocercas') : 'El dispositivo no cuenta con geocercas asignadas'">
                  <feather :type="!data.item.select ? 'alert-circle' : 'x-circle'" class="feather-sm mr-2"></feather>
                </b-button>
                <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                  :style="!data.item.hasPosition ? 'color: lightgray; cursor: auto;' : ''"
                  @click="data.item.hasPosition ? openModal(data.item) : null" v-b-tooltip.hover
                  :title="data.item.hasPosition ? data.item.icono === 0 ? $t('vMonitoreo.dispRedonda') : $t('vMonitoreo.ocultarDispRedonda') : 'El dispositivo no cuenta con posiciones registradas'">
                  <feather :type="data.item.icono === 0 ? 'target' : 'disc'" class="feather-sm mr-2"></feather>
                </b-button>
              </div>
            </template>
          </base-table>
        </b-tab>
        <!-- Pestaña para mostrar las ubicaciones -->
        <b-tab title="Ubicaciones">
          <div>
            <b-button :disabled="emptyLocations" @click="selectAllRows"
              :class="banderaUbicaciones ? 'mb-1 mr-2 w-100' : 'mb-2 mr-2 d-flex align-items-center justify-content-center w-100'"
              :variant="banderaUbicaciones ? undefined : 'info'" style="color: white">
              {{ banderaUbicaciones ? 'Ocultar ubicaciones' : 'Mostrar ubicaciones' }}
            </b-button>
            <b-button v-if="!formMarcador" @click="agregarMarcador"
              class="mb-2 mr-2 d-flex align-items-center justify-content-center w-100" variant="info"
              style="color: white">
              <feather type="map-pin" class="feather-sm mr-1"></feather>{{ $t('vMonitoreo.agregarUbicacion') }}
            </b-button>
          </div>
          <input-buscar class="mb-2" layout="column" :filter="filterSearch"
            @input="filterSearch = $event"></input-buscar>
          <base-table :items="marcadores" :fields="fields" :totalRows="totalRowsMarkers" :filter="filterSearch"
            :perPage="9" @filtered="onFilteredMarkers">
            <template #cell(nombre)="data">
              <div>{{ formatDeviceName(data.item) }}</div>
            </template>
            <template #cell(acciones)="data">
              <div class="row icons" style="padding: 0.8rem">
                <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="verMarcador(data.item)"
                  v-b-tooltip.hover :title="!data.item.select ? $t('Gral.ver') : $t('configDispositivos.ocultar')">
                  <feather :type="marcadoresSeleccionados[data.item.id] ? 'eye' : 'eye'" class="feather-sm mr-2"
                    :style="isVisibleMap(marcadoresSeleccionados[data.item.id])">
                  </feather>
                </b-button>
                <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="editarMarcador(data.item)"
                  v-b-tooltip.hover :title="$t('Gral.editar')">
                  <feather type="edit" class="feather-sm mr-2"></feather>
                </b-button>
                <b-button variant="link" class="p-0 border-0 shadow-none text-reset"
                  @click="eliminarMarcador(data.item)" v-b-tooltip.hover :title="$t('Gral.editar')">
                  <feather type="trash-2" class="feather-sm mr-2"></feather>
                </b-button>
              </div>
            </template>
          </base-table>
        </b-tab>
      </b-tabs>
    </panel-component>

    <!-- Panel de alertas -->
    <panel-component id="sidebar-alertas" :visible.sync="isSidebarBVisible">
      <b-tabs content-class="mt-3">
        <b-tab title="Alertas">
          <date-range-picker @inputDate="dateFilter"></date-range-picker>
          <b-button @click="alertsFilterBtn = !alertsFilterBtn"
            :class="alertsFilterBtn ? 'mb-2 mr-2 w-100' : 'mb-2 mr-2 d-flex align-items-center justify-content-center w-100'"
            :variant="alertsFilterBtn ? undefined : 'info'" style="color: white">
            <feather type="sliders" class="feather-sm mr-2"></feather>
            {{ alertsFilterBtn ? $t('vMonitoreo.ocultarFiltro') : $t('vMonitoreo.filtro') }}
          </b-button>
          <b-form-select v-if="alertsFilterBtn" id="alertFilter" v-model="alertFilter" :options="typeAlertList"
            required>
          </b-form-select>
          <base-table-alertas :key="currentPage" :items="notifications" :fields="[{}, this.$t('vMonitoreo.alertas')]"
            :totalRows="totalR" :perPage="perPage" :currentPage.sync="currentPage" @update:currentPage="onPageChange">
            <template #cell(nombre)="data">
              <div>{{ formatDeviceName(data.item) }}</div>
            </template>
            <template #cell(Alertas)="item">
              <div class="d-flex align-items-center mt-0">
                <b-img v-if="alertItemTable.some(alert => alert.type === item.item.tipo)"
                  :src="alertItemTable.find(alert => alert.type === item.item.tipo).icon" class="rounded-circle"
                  style="width: 14%">
                </b-img>

                <div class="ml-2 w-75">
                  <span class="h6 fw-medium mb-2">{{ item.item.tipo }}</span>
                  <span class="h6 text-truncate d-block text-muted mb-0">
                    {{ item.item.descripcionAlerta }}
                  </span>
                  <span class="h6 text-truncate d-block text-muted mb-0">
                    {{ $t('Gral.latitud') }}: {{ Number.parseFloat(item.item.latitud).toFixed(7) }}
                  </span>
                  <span class="h6 text-truncate d-block text-muted mb-0">
                    {{ $t('Gral.longitud') }}: {{ Number.parseFloat(item.item.longitud).toFixed(7) }}
                  </span>
                  <div v-if="item.item.tipo != 'Geocerca'">
                    <span class="h6 text-truncate d-block text-muted mb-0 alertas-width">
                      {{ $t('vMonitoreo.velocidad') }}: {{ Number.parseFloat(item.item.velocidad).toFixed(2) }} km/h
                    </span>
                    <span class="h6 text-truncate d-block text-muted mb-0">
                      {{ $t('vMonitoreo.bateria') }}: {{ item.item.bateria }}
                    </span>
                  </div>
                  <span v-else class="h6 text-truncate d-block text-muted mb-0 break-all">
                    {{ $t('vGeocercas.geocerca') }}:
                    <a :href="item.item.link" target="_blank" class="text-primary break-all">

                      Ver en Google Maps
                    </a>
                  </span>
                  <div class="row mt-1 mb-0 justify-content-center">
                    <b-col cols="6" class="text-center">
                      <h6 class="text-muted mb-0 alertas">{{ item.item.hora }}</h6>
                    </b-col>
                    <b-col cols="6" class="text-center">
                      <h6 class="text-muted mb-0 alertas">
                        {{ item.item.fecha == fechaHoy ? $t('Gral.hoy') : item.item.fecha }}
                      </h6>
                    </b-col>
                  </div>
                </div>
                <div>
                  <b-button variant="link" class="p-0 border-0 shadow-none text-reset" @click="verAlertas(item.item)"
                    v-b-tooltip.hover :title="item.item.select ? $t('configDispositivos.ocultar') : $t('Gral.ver')">
                    <feather :type="alertasSeleccionadas[item.item.id] ? 'eye-off' : 'eye'" class="feather-sm mr-2">
                    </feather>
                  </b-button>
                </div>
              </div>
            </template>
          </base-table-alertas>
        </b-tab>
      </b-tabs>
    </panel-component>

    <!-- Boton Agregar Ubicación -->
    <b-row class="d-flex">
      <b-col cols="12" md="auto">
        <b-button v-if="!formMarcador" class="w-100 mt-2 d-flex align-items-center justify-content-center"
          variant="info" style="color:white" @click="agregarMarcador">
          <feather type="map-pin" class="feather-sm mr-1"></feather>
          {{ $t('vMonitoreo.agregarUbicacion') }}
        </b-button>
      </b-col>
    </b-row>

    <!-- Formulario para agregar ubicacion -->
    <div v-show="formMarcador" class="mt-4">
      <b-card-group deck>
        <b-card border-variant="primary" header-bg-variant="azul" header-class="h2 text-center text-white"
          :header="$t('vMonitoreo.agregarUbicacion')" class="border">
          <b-card-text class="card-text card-text-ultra">
            <div v-if="!editMarker" style="text-align: justify;">
              {{ $t('configDispositivos.insAgrUbic') }} <strong>{{ $t('configDispositivos.dibujarMarcador') }}</strong>
              {{ $t('configDispositivos.insAgrUbicA') }} <feather type="map-pin" class="feather-sm"></feather>.
              {{ $t('configDispositivos.insAgrUbicB') }}
            </div>
            <div v-else>
              {{ $t('configDispositivos.instruccionEditar') }}
              <ol style="padding-left: 3%; padding-top: 1%;">
                <li style="padding-bottom: 1%;">{{ $t('configDispositivos.insMarcA') }} <strong>{{ $t('Gral.editar')
                    }}</strong>
                  {{ $t('configDispositivos.insMarcB') }} <feather type="edit" class="feather-sm"></feather>.
                  {{ $t('configDispositivos.insMarcC') }}
                </li>
                <li v-html="$t('configDispositivos.insEditarUbicacionA', {
                  0: '<b>' + $t('Gral.nombre') + '</b>',
                  1: '<b>' + $t('Gral.latitud') + '</b>',
                  2: '<b>' + $t('Gral.longitud') + '</b>',
                })">
                </li>
              </ol>
            </div>

            <div class="mt-2">
              <span><strong>*</strong>: {{ $t('Gral.camposObligatorios') }}</span>
              <b-row>
                <b-col>
                  <b-form-group :label="$t('Gral.nombre') + '* :'" label-for="nombre" label-align="center">
                    <b-form-input id="nombre" v-model="marcador.nombre" :state="nombreState" required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group :label="$t('Gral.latitud') + '* :'" label-for="latitud" label-align="center">
                    <b-form-input type="number" step="0.00000001" max="90" min="-90" id="latitud" ref="latitud"
                      v-model="marcador.latitud" :state="latitudState"
                      invalid-feedback="Latitud debe estar entre -90 y 90" required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group :label="$t('Gral.longitud') + '* :'" label-for="longitud" label-align="center">
                    <b-form-input type="number" step="0.00000001" max="180" min="-180" id="longitud" ref="longitud"
                      v-model="marcador.longitud" :state="longitudState"
                      invalid-feedback="Longitud debe estar entre -90 y 90" required>
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="row icons">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-lg-flex justify-content-lg-end">
                <b-btn :variant="undefined" class="w-100" style="color: white;" @click="cancelarMarcador">
                  {{ $t('Gral.cancelar') }}
                </b-btn>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <b-btn variant="info" class="w-100" style="color: white;" @click="registrarMarcador">
                  {{ $t('configDispositivos.guardarUbicacion') }}
                </b-btn>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-group>
    </div>

    <!--Modal dispositivosRedonda-->
    <b-modal id="nerbyDevicesModal" v-model="showModal" hide-footer centered>
      <b-card-text class="ml-4 mr-4">
        <div style="margin-top: -30px;" class="h4 text-center">
          {{ $t('vMonitoreo.msgRedonda') + ': ' + nearbyDevice.nombre }}
        </div>
        <div class="text-justify">
          <p v-html="$t('vMonitoreo.msgDescRedonda')"></p>
        </div>
        <div class="row">
          <b-col cols="12" sm="4">
            <label for="“radio”">{{ this.$t('Gral.radio') }}* :</label>
            <b-form-input type="number" step="1" min="1" max="1000" id="radioV" v-model="radioSettings.radius">
            </b-form-input>
          </b-col>
          <b-col cols="12" sm="8">
            <b-form-group id="input-group-2" :label="$t('Gral.medida') + '*:'">
              <b-form-select v-model="radioSettings.distanceUnit" :options="distanceUnitTranslate">
              </b-form-select>
            </b-form-group>
          </b-col>
        </div>
        <p style="margin-top: -20px; font-size: 14px; font-weight: 400;">* {{ $t('Gral.camposObligatorios') }}</p>
        <b-row class="text-center" style="margin-top: -20px;">
          <b-col cols="4">
            <b-btn class="w-100" @click="OcultarModalRedonda()" style="color: white">
              {{ $t('Gral.cancelar') }}
            </b-btn>
          </b-col>
          <b-col>
            <b-btn class="w-100" variant="info" style="color: white" :disabled="validarDatosRedonda"
              @click="calcularDispositivosRedonda()">
              {{ $t('vMonitoreo.dispRedonda') }}
            </b-btn>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
  </b-col>
</template>
<script>
import UsersDataService from '../../../services/UsersDataService';
import DevicesDataService from "../../../services/DevicesDataService";
import MarcadoresDataService from "../../../services/MarcadoresDataService";
import AlertasDataService from "../../../services/AlertasDataService";
import PosicionesDataService from "../../../services/PosicionesDataService";
import GeocercaDataService from "../../../services/GeocercaDataService";
import Crypto from '../../../services/Crypto';

import { mapState } from "vuex";
import Mapa from '../../components/Map';
import PanelComponent from './../../components/PanelComponent';
import InputBuscar from '../../components/InputBuscar';
import BaseTableAlertas from '../../components/BaseTableAlertas';
import BaseTable from '../../components/BaseTable';
import DateRangePicker from '../../components/DateRangePicker.vue';
import { customizedSweetAlert, generalSweetAlert, destruirAlerta } from '../../../utils/Utils';
import {
  getTypeIcon, editMarkerOnMap, nuevoZoom
} from '../../components/MapFunctions';
import { eventBus } from '@/main'

import { EventBusNotificaciones } from '../../../utils/event-bus';
import AccionesDataService from "../../../services/AccionesDataService";

export default {
  components: {
    Mapa,
    PanelComponent,
    InputBuscar,
    BaseTableAlertas,
    BaseTable,
    DateRangePicker
  },
  data() {
    return {
      radioGeocerca: 0,
      abortController: null,
      banderaGps: false,
      key: sessionStorage.getItem('key'),
      isRealTimeLocationUser: false,
      options: {
        useLocateControl: true,
        useControlLocation: true,
        useControlLegend: true,
        useMarkLocation: null,
        useUserLocation: null,
        imgUrl: this.$t('Gral.imgLeyenda'),
      },
      showModal: false,
      banderaVerTodos: false,
      banderaGeocercas: false,
      alertsFilterBtn: false,
      alertFilter: null,
      filterSearch: null,
      filterDate: null,
      tabIndex: 0,
      formMarcador: false,
      totalRowsDevices: 0,
      totalRowsMarkers: 0,
      dispositivosTodos: [],
      marcadores: [],
      currentPage: 1,
      fields: [
        { key: 'nombre', label: 'Nombre', sortable: true, class: 'w-50' },
        { key: 'acciones', label: 'Acciones', class: 'w-50' }
      ],
      typeAlertList: [
        { text: this.$t('vMonitoreo.todas'), value: null, },
        { text: this.$t('vMonitoreo.auxilio'), value: 'Auxilio', },
        { text: this.$t('vMonitoreo.bateriaBaja'), value: 'Batería baja', },
        { text: this.$t('vMonitoreo.geocerca'), value: 'Geocerca', },
        { text: this.$t('vMonitoreo.impacto'), value: 'Impacto', },
        { text: this.$t('vMonitoreo.movimiento'), value: 'Movimiento', },
        { text: this.$t('vMonitoreo.velocidad'), value: 'Velocidad', },
      ],
      alertItemTable: [
        { type: 'Auxilio', icon: '/assets/img/iconoAuxilio.svg' },
        { type: 'Batería baja', icon: '/assets/img/iconoBateriaBaja.svg' },
        { type: 'Geocerca', icon: '/assets/img/iconoGeocerca.svg' },
        { type: 'Impacto', icon: '/assets/img/iconoImpacto.svg' },
        { type: 'Movimiento', icon: '/assets/img/iconoMovimiento.svg' },
        { type: 'Velocidad', icon: '/assets/img/iconoVelocidad.svg' },
      ],
      notifications: [],
      notificationsAux: [],
      fechaHoy: null,
      currentP: 1,
      totalR: 0,
      perP: 3,
      posiciones: [],
      posicionesDibujadas: [],

      cargaPosicionesDispo: false,
      cargaPosicionesTodos: false,

      interval: null,
      intervaloDispositivo: null,
      intervaloActualizacionAlertas: 5000,
      intervaloActualizacionDispositivos: 5000,

      //objeto para cuando se selecciona un solo dispositivo de la tabla.
      dispositivoGpsSeleccionado: null,
      alertaSeleccionada: null,
      banderaOrigenGeocerca: false,
      banderaGpsSeleccion: null,
      geocercas: [],
      listaGeocercas: [],
      geocercaSeleccionada: null,
      arrayGps: [],

      radioSettings: {
        radius: "",
        distanceUnit: null,
      },
      distanceUnitTranslate: [
        { text: this.$t('vMonitoreo.unidadLong'), value: null, },
        { text: this.$t('vMonitoreo.metros'), value: "Metros." },
        { text: this.$t('vMonitoreo.km'), value: "Kilómetros." },
      ],

      /** Variable de control para conocer no hay dispositivos registrados */
      emptyDevices: true,
      /** Variable de control para conocer no hay geocercas registradas */
      emptyGeofences: true,

      nearbyDevice: {},
      listaPosiRedonda: null,


      // === Ubicaciones guardadas ===
      banderaUbicaciones: false,
      emptyLocations: true,
      listaMarcadores: [],
      marcador: {
        nombre: "",
        latitud: null,
        longitud: null,
      },
      layerMarker: null,
      editMarker: false,


      // === Alertas ===
      listaAlertas: [],


      /**
       * Representa una matriz de objetos de latitud y longitud.
       * Cada objeto contiene las siguientes propiedades:
       * - `entity`: La entidad asociada, puede representar un marcador o polígono dentro del mapa.
       * - `lat`: La coordenada de latitud de la entidad asociada.
       * - `lng`: La coordenada de longitud de la entidad asociada.
       */
      latlngs: [
        // {
        //   entity: null,
        //   lat: null,
        //   lng: null,
        // }
      ],
      isSidebarAVisible: false,
      isSidebarBVisible: false,

      alertasSeleccionadas: {},
      marcadoresSeleccionados: {},
      zoom: 16,
      mapReference: null,
      arrDispos: [],
      arrMarkers: [],
      cargarVariosDispositivos: false,

      perPage: 3,
      totalPaginadoAlertas: 0,

      arrMarkersUbicaciones: [],

      oMarcadoresSeleccionados: {},

      validatedUbicacion: false,

    }
  },
  watch: {

    tabIndex(newValue) {
      // Se limpia la variable de control para botón
      // this.banderaVerTodos = false;
      this.filterSearch = '';
    },
    alertFilter(newFilter) {
      this.alertFilter = newFilter;
      this.currentPage = 1;
      if (this.filterDate == null) {
        this.obtenerAlertasConPaginado()
      } else {
        this.dateFilter()
      }
    },

    async cargaPosicionesTodos(value) {
      const data = {
        matricula: sessionStorage.username,
        nombreUsuario: sessionStorage.nombreUsuario
      }

      let that = this;
      function obtenPosicionesTodos() {
        PosicionesDataService.getAll(data, that.key)
          .then(async (response) => {
            if (!that.banderaVerTodos) return; // si ya ocultaron, no hacer nada
            let decoded = await Crypto.desencriptar(response.data, that.key);
            const nuevasPosiciones = decoded.map(that.getDisplayPosicion);

            nuevasPosiciones.forEach((posicionNueva, index) => {
              const posicionVieja = that.posiciones[index];

              // Si NO existe posición vieja → crear marker
              if (!posicionVieja) {
                posicionNueva.marker = that.renderEntityOnMap(posicionNueva, "device");

                // Hacer zoom solo al primer render
                if (!that.zoomInicialRealizado) {
                  that.$refs.map.focusPositionOnMap(
                    { lat: posicionNueva.latlng.lat, lng: posicionNueva.latlng.lng },
                    16
                  );
                  that.zoomInicialRealizado = true;
                }

                return;
              }

              // Si existe marker y la posición NO cambió → no hacer nada (evita parpadeo)
              if (
                posicionVieja.latlng.lat === posicionNueva.latlng.lat &&
                posicionVieja.latlng.lng === posicionNueva.latlng.lng
              ) {
                posicionNueva.marker = posicionVieja.marker;
                return;
              }

              // Si la posición cambió → borrar y recrear SOLO ese marker
              that.$refs.map.removeEntityFromMap([posicionVieja.marker]);
              posicionNueva.marker = that.renderEntityOnMap(posicionNueva, "device");
            });

            // Actualizar lista final
            that.posiciones = nuevasPosiciones;

            // 🔹 Zoom según cantidad de GPS visibles
            const markersVisibles = that.posiciones.map(p => p.marker).filter(Boolean);
            if (markersVisibles.length === 1) {
              that.$refs.map.focusPositionOnMap(markersVisibles[0].getLatLng(), 16);
            } else if (markersVisibles.length > 1) {
              that.$refs.map.nuevoZoom(markersVisibles);
            }
          })
          .catch((e) => { console.log(e); });
      }


      if (value) {
        this.sondeoPosiciones = obtenPosicionesTodos;
        this.interval = setInterval(obtenPosicionesTodos, this.intervaloActualizacionDispositivos);
      } else {
        if (this.interval != null) {
          clearInterval(this.interval);
        }
      }
    },

    async cargarVariosDispositivos(value) {

      let that = this;
      function obtenerPosicionDispos() {
        that.arrDispos.forEach((device) => {
          PosicionesDataService.getPositionByDevicesId(device.dispositivo, that.key)
            .then(async (response) => {
              const decoded = await Crypto.desencriptar(response.data, that.key);
              const posicion = decoded.map(that.getDisplayPosicion)[0]
              device.marker = that.renderEntityOnMap(posicion, 'device')
              const markerIndex = that.arrMarkers.findIndex((marker) => marker.idDevice === device.id);
              if (markerIndex !== -1) {
                that.arrMarkers[markerIndex] = device.marker;
              }
              // 🔥 Centrar el mapa en la nueva posición del dispositivo
              if (posicion?.latlng && that.arrDispos.length === 1) {
                that.$refs.map.focusPositionOnMap(
                  { lat: posicion.latlng.lat, lng: posicion.latlng.lng },
                  16
                );
              }
            }).catch((e) => {
              console.error(e);
            });
          that.$refs.map.removeEntityFromMap(device)
        })
      }


      if (value) {
        // si la bandera cargaPosicionesDispo es true, ejecuta la funcion obtenerPosicionDispo cada 5 segundos
        console.log("se ejecuto a los 5 seg");

        this.sondeoPosiciones = obtenerPosicionDispos;
        this.intervaloDispositivo = setInterval(obtenerPosicionDispos, this.intervaloActualizacionDispositivos);
      } else {
        // si la bandera cargaPosicionesDispo es false, deja de ejecutar la funcion obtenerPosicionDispo
        if (this.intervaloDispositivo != null) {
          clearInterval(this.intervaloDispositivo);
        }
      }
    },

    async cargaPosicionesDispo(value) {
      let that = this;
      function obtenerPosicionDispo() {
        PosicionesDataService.getPositionByDevicesId(that.dispositivoGpsSeleccionado.dispositivo, that.key)
          .then(async (response) => {
            const decoded = await Crypto.desencriptar(response.data, that.key);
            const posicion = decoded.map(that.getDisplayPosicion)[0]
            that.dispositivoGpsSeleccionado.marker = that.renderEntityOnMap(posicion, 'device')
            nuevoZoom([that.dispositivoGpsSeleccionado.marker], that.zoom);
          }).catch((e) => {
            console.error(e);
          });
        this.$refs.map.removeEntityFromMap(that.dispositivoGpsSeleccionado)
      }
      if (value) {
        // si la bandera cargaPosicionesDispo es true, ejecuta la funcion obtenerPosicionDispo cada 5 segundos
        this.sondeoPosiciones = obtenerPosicionDispo;
        this.intervaloDispositivo = setInterval(obtenerPosicionDispo, this.intervaloActualizacionDispositivos);
      } else {
        // si la bandera cargaPosicionesDispo es false, deja de ejecutar la funcion obtenerPosicionDispo
        if (this.intervaloDispositivo != null) {
          clearInterval(this.intervaloDispositivo);
        }
      }
    },

    async notificationsAux() {
      //¿Hay un filtro válido?
      const hasFilter = this.alertFilter !== null && this.alertFilter !== undefined;

      //Filtra o deja la lista intacta
      this.notifications = hasFilter
        ? this.notificationsAux.filter(alerta => alerta.tipo === this.alertFilter)
        : this.notificationsAux;

      //Calcula el total (una sola línea)
      this.totalR = this.notifications.length === 0 ? 0 : this.totalPaginadoAlertas;
    },
  },
  computed: {
    ...mapState(['locale']),
    validarDatosRedonda() {
      return !(this.radioSettings.distanceUnit !== null && this.radioSettings.radius !== "");
    },

    nombreState() {
      if (!this.validatedUbicacion) return null;
      return this.marcador.nombre.trim().length > 0;
    },

    latitudState() {
      if (!this.validatedUbicacion) return null;
      const lat = this.marcador.latitud;
      return lat !== null && lat >= -90 && lat <= 90;
    },

    longitudState() {
      if (!this.validatedUbicacion) return null;
      const long = this.marcador.longitud;
      return long !== null && long >= -180 && long <= 180;
    },


  },
  async mounted() {
    const sToken = sessionStorage.getItem("token")
    const validToken = await AccionesDataService.validarTokenExistenteAllowList(sToken, this.key);
    if (!validToken) {
      this.cerrarSesion();
      return
    }

    //Evento bus para abrir el menu vertical de las alertas
    EventBusNotificaciones.$on('toggle-sidebar', this.toggleSidebar);
    // Escucha el evento global 'mapZoomChanged'
    this.$root.$on('mapZoomChanged', zoom => {
      this.zoom = zoom; // Actualiza el valor del zoom cuando cambia
    });
    this.getCurrentLocation();
    await this.obtenerDispositivos();
    this.obtenerPosiciones();
    this.obtenerGeocercas();
    this.obtenerMarcadores();
    this.obtenerAlertasConPaginado();
    this.fechaHoy = new Date().toJSON().slice(0, 10).replaceAll("-", "/");
    this.reloadNotificaciones();
    // Agrega un listener de eventos para el zoom
    this.mapReference.on('zoomend', () => {
      this.zoom = this.mapReference.getZoom();
    });

    document.addEventListener('visibilitychange', this.refrescarAlVolver);



  },
  beforeDestroy() {
    console.log('[Monitoreo] beforeDestroy: limpiando intervalo y eventos');

    EventBusNotificaciones.$off('toggle-sidebar', this.toggleSidebar);
    document.removeEventListener('visibilitychange', this.refrescarAlVolver);

    //Funcionalidad para borrar el setInterval al salir del componente
    if (this.intervaloDispositivo !== null) {
      clearInterval(this.intervaloDispositivo);
      this.intervaloDispositivo = null;
    }
  },
  methods: {
    /**
     * Método que actualiza de inmediato las posiciones al volver a la pestaña, ya que el navegador
     * pausa o ralentiza los intervalos mientras está en segundo plano
     */
    refrescarAlVolver() {
      if (document.visibilityState === 'visible' && typeof this.sondeoPosiciones === 'function') {
        this.sondeoPosiciones();
      }
    },

    cerrarSesion() {
      sessionStorage.clear();
      localStorage.clear();
      localStorage.removeItem("tokenSesion");
      localStorage.removeItem("servidor");
      localStorage.removeItem("aciqui_instance");

      destruirAlerta();
      this.$router.push({
        path: "/"
      });
    },

    isVisibleMap(esVisible) {

      if (esVisible) {
        return {
          color: 'black',
          background: '#28e228',
          borderRadius: '50%',
          fontSize: '16px'
        };
      }
      return {
        color: '#54667a'
      };

    },

    toggleSidebar(sidebar) {
      if (sidebar === "A") {
        this.isSidebarAVisible = !this.isSidebarAVisible;
        if (this.isSidebarAVisible) this.isSidebarBVisible = false;
      } else if (sidebar === "B") {
        this.isSidebarBVisible = !this.isSidebarBVisible;
        if (this.isSidebarBVisible) this.isSidebarAVisible = false;
      }
    },

    async reloadNotificaciones() {
      eventBus.$on("alertas", (data) => {
        if (data === "recargarAlertas") {
          //this.obtenerAlertas()
          this.obtenerAlertasConPaginado();
        }
      });
    },

    // === Métodos que se ejecutan al cargar la vista ===
    async getCurrentLocation() {
      try {
        const response = await UsersDataService.getUbicacionTiempoReal();
        this.options.useUserLocation = await Crypto.desencriptar(response.data, this.key);
      } catch {
        generalSweetAlert('Error al obtener la ubicación en tiempo real', 'error');
      }
    },
    async obtenerDispositivos() {
      try {
        const response = await DevicesDataService.getAllOrden();
        this.dispositivosTodos = await Crypto.desencriptar(response.data, this.key);

        if (sessionStorage.idRol === process.env.VUE_APP_ID_MASTER && sessionStorage.usuarioFiltro) {
          const user = JSON.parse(sessionStorage.usuarioFiltro);


          if (user.rol.id === process.env.VUE_APP_ID_ADMINISTRADOR) {
            const mensaje = "Vista " + user.rol.role;
            generalSweetAlert(mensaje, 'success')
            this.dispositivosTodos = this.dispositivosTodos.filter(value => value.area?.id === user.area.id);
          } else {
            const mensaje = "Vista " + user.rol.role;
            generalSweetAlert(mensaje, 'success')
            this.dispositivosTodos = this.dispositivosTodos.filter(value =>
              value.usuarios?.some(u => u.id?.toString() === user.id.toString())
            );
          }
        }
        this.emptyDevices = this.dispositivosTodos.length > 0 ? false : true;
        this.totalRowsDevices = this.dispositivosTodos.length;
      } catch (error) {
        console.error(error);
      }
    },
    async obtenerPosiciones() {
      const data = {
        matricula: sessionStorage.username,
        nombreUsuario: sessionStorage.nombreUsuario
      }
      try {
        const response = await PosicionesDataService.getAll(data, this.key);
        const decoded = await Crypto.desencriptar(response.data, this.key)
        this.posiciones = decoded.map(this.getDisplayPosicion);

        // Mostar a Angelica
        this.dispositivosTodos = this.dispositivosTodos.map(itemA => {
          const itemB = this.posiciones.find(itemB => itemB.dispositivo === itemA.id);
          return { ...itemA, hasPosition: !!itemB };
        });
      } catch (error) {
        console.error(error);
      }
    },

    async obtenerGeocercas() {
      try {
        const response = await GeocercaDataService.getAll();
        const decoded = await Crypto.desencriptar(response.data, this.key);

        // 1. Filtrar geocercas que tengan dispositivos válidos
        this.geocercas = decoded.filter(geocerca =>
          geocerca.dispositivos && geocerca.dispositivos.some(d => d !== null)
        );

        // 2. Crear un Set de IMEIs con geocerca para mejorar el rendimiento
        // Usamos String() para evitar fallos si un imei viene como número y otro como string
        const imeisConGeocerca = new Set(
          this.geocercas.flatMap(g => g.dispositivos.map(d => String(d.imei)))
        );

        // 3. Reasignar el array usando .map() para asegurar la reactividad en Vue
        this.dispositivosTodos = this.dispositivosTodos.map(dispositivo => ({
          ...dispositivo,
          hasGeofence: imeisConGeocerca.has(String(dispositivo.imei))
        }));

        this.emptyGeofences = this.geocercas.length === 0;
      } catch (error) {
        console.error("Error en obtenerGeocercas:", error);
      }
    },
    async obtenerMarcadores() { // El metodo del bk no es del todo funcional, los registros deben obtenerse de acuerdo al tipo de usuario
      try {
        const response = await MarcadoresDataService.getAll();
        this.marcadores = await Crypto.desencriptar(response.data, this.key);

        if (sessionStorage.idRol === process.env.VUE_APP_ID_MASTER && sessionStorage.usuarioFiltro) {
          const user = JSON.parse(sessionStorage.usuarioFiltro);
          const isAdmin = user.rol.id === process.env.VUE_APP_ID_ADMINISTRADOR;
          this.marcadores = this.marcadores.filter(value => {
            if (isAdmin) return value.usuario.area && value.usuario.area.id === user.area.id;
            else return value.usuario.id === user.id;
          });
        }
        this.emptyLocations = this.marcadores.length > 0 ? false : true;
        this.totalRowsMarkers = this.marcadores.length;
      } catch (error) {
        console.error(error)
      }
    },
    async obtenerAlertas() {
      try {
        const response = await AlertasDataService.getAll();
        this.notifications = await Crypto.desencriptar(response.data, this.key);
        this.notificationsAux = this.notifications;
        this.totalR = this.notifications.length;
      } catch (error) {
        console.error(error);
      }
    },

    async obtenerAlertasConPaginado() {
      try {

        const data = {
          page: this.currentPage - 1, // backend espera base 0
          size: this.perPage,
          tipo: this.alertFilter || null,
        };

        const response = await AlertasDataService.getAllConPaginado(data, this.key);
        const result = await Crypto.desencriptar(response.data, this.key);


        this.notifications = [...result.data];
        this.totalPaginadoAlertas = result.total;
        this.totalR = (result.data.length == 0 ? 0 : result.total);
      } catch (error) {
        console.error(error);
      }
    },

    // === Métodos requeridos para la interacción con las tablas ===
    verTodosDispositivos() {
      // 🧽 LIMPIAR MARCADORES INDIVIDUALES SI EXISTEN
      if (this.arrDispos.length > 0) {
        this.arrDispos.forEach(device => {
          if (device.marker) {
            this.$refs.map.removeEntityFromMap(device);
          }
        });

        this.arrDispos = [];
        this.arrMarkers = [];
        this.cargarVariosDispositivos = false;
      }

      if (!this.banderaVerTodos) {
        let arrayDispos = [];
        if (this.dispositivoGpsSeleccionado) {
          this.$refs.map.removeEntityFromMap(this.dispositivoGpsSeleccionado);
          this.cargaPosicionesDispo = false;
        }

        this.dispositivosTodos.forEach(dispositivo => {
          this.posiciones.find(posicion => posicion.imei === dispositivo.imei) ? dispositivo.sim = true : dispositivo.sim = false;
        });

        this.posiciones.forEach(posicion => {
          posicion.marker = this.renderEntityOnMap(posicion, 'device')
          arrayDispos.push(posicion.marker);
          this.posicionesDibujadas.push(posicion);
        });
        this.$refs.map.nuevoZoom(arrayDispos);

      } else {
        // Ocultar todos
        if (this.interval != null) {
          clearInterval(this.interval);
          this.interval = null;
        }

        this.posicionesDibujadas = [];
        this.$refs.map.removeEntityFromMap(this.posiciones, true);
        this.dispositivosTodos.forEach(dispositivo => dispositivo.sim = dispositivo.hasPosition ? false : dispositivo.sim);
      }
      this.cargaPosicionesTodos = !this.cargaPosicionesTodos;
      this.banderaVerTodos = !this.banderaVerTodos;
    },

    /**
    * Funcion que permite ver un dispositivo a la vez en el mapa, si existe algun otro, lo deshabilita del mapa
    * @param datos el dispositivo actual
    */
    async verDispositivo(datos) {

      if (this.banderaVerTodos) {
        if (datos.sim) {
          const indexPosition = this.posicionesDibujadas.findIndex(posicion => posicion.imei === datos.imei);
          const posicion = this.posiciones.find(posicion => posicion.imei === datos.imei);
          this.$refs.map.removeEntityFromMap(posicion);
          if (indexPosition !== -1) this.posicionesDibujadas.splice(indexPosition, 1);
          if (this.posicionesDibujadas.length === 0) {
            this.banderaVerTodos = false;
            this.cargaPosicionesTodos = false;
          }
        } else {
          const posicion = this.posiciones.find(posicion => posicion.imei === datos.imei);
          posicion.marker = this.renderEntityOnMap(posicion, 'device');
          this.posicionesDibujadas.push(posicion);
        }
        datos.sim = !datos.sim;
        this.cargaPosicionesTodos = false;
      } else {
        // ✅ Modo "individual"
        const posicion = this.posiciones.find(posicion => posicion.imei === datos.imei);
        if (!datos.sim) {
          // Mostrar marcador
          posicion.marker = this.renderEntityOnMap(posicion, 'device', true);
          this.arrDispos.push(posicion);
          this.arrMarkers.push(posicion.marker);
          posicion.marker.idDevice = posicion.id;

          if (this.arrDispos.length === 1) {
            this.$refs.map.focusPositionOnMap(posicion.latlng, 16);
          } else {
            this.$refs.map.nuevoZoom(this.arrMarkers)
          }
          this.cargarVariosDispositivos = true;
        } else {
          // 🔴 Ocultar marcador
          this.$refs.map.removeEntityFromMap(posicion, true);

          this.arrDispos = this.arrDispos.filter((device) => device.imei !== posicion.imei);
          this.arrMarkers = this.arrMarkers.filter((marker) => marker.idDevice !== posicion.id);

          if (this.arrDispos.length === 0) {
            this.cargarVariosDispositivos = false;
          }

          posicion.marker = null;
        }
        datos.sim = !datos.sim;
      }
    },

    clearMapContent() {

      // 🔴 Eliminar todos los marcadores visibles
      this.arrMarkers.forEach((marker) => {
        if (marker) {
          this.$refs.map.removeEntityFromMap(marker);
        }
      });

      // 🧼 Limpiar referencias en arrDispos
      this.arrDispos.forEach((device) => {
        if (device && device.marker) {
          device.marker = null;
        }
      });

      // 🧼 Limpiar referencias en posicionesDibujadas
      this.posicionesDibujadas.forEach((posicion) => {
        if (posicion && posicion.marker) {
          posicion.marker = null;
        }
      });


    },

    /*verGeocercas() {
      let arrayLatitud = [];
      let arrayLongitud = [];
      let p = 0, ban = 0; //p:--> Actua como indice para crecer y acceder al arreglo listaGeocercas, ban: --> es solo un contador para el total de geocercas encontradas
      if (!this.geocercas) {
        generalSweetAlert(this.$t('vMonitoreo.msgSinGeocercas'), 'info');
        return;
      }

      if (!this.banderaGeocercas) {
        this.geocercas.forEach(geocerca => {
          let nombres = '';
          const devicesList = geocerca.dispositivos;
          nombres = devicesList.map(device => device.nombre).join(', ');
          ban++;
          let circulo = null;
          if (geocerca.locate.type === 'Point') {
            arrayLatitud.push(geocerca.latitud);
            arrayLongitud.push(geocerca.longitud);
            this.radioGeocerca = Math.max(Number.parseFloat(geocerca.radio), Number.parseFloat(this.radioGeocerca));
            const propertiesGeofence = {
              lat: geocerca.latitud,
              lng: geocerca.longitud,
              radio: geocerca.radio * 1,
              color: geocerca.color,
            }
            geocerca.lblDevice = "<b>" + this.$t('dispositivos') + ":</b> " + nombres;
            const popupGeofence = this.contenidoMarkerGeofences(geocerca);
            circulo = this.$refs.map.renderEntityOnMap(propertiesGeofence, popupGeofence);
            this.listaGeocercas[p] = circulo;
            p++;
          }
          if (geocerca.locate.type === 'Polygon') {
            let arreglo = [];
            let item = geocerca.locate.coordinates[0];
            for (let w = 0; w < item.length; w++) {
              arreglo.push([item[w][1], item[w][0]]);
              arrayLatitud.push(item[w][1]);
              arrayLongitud.push(item[w][0]);
            }
            const pop = {
              nombre: geocerca.nombre,
              lblDevice: "<b>" + this.$t('dispositivos') + ":</b> " + nombres,
              alerta: geocerca.alerta,
            }
            const propertiesGeofence = {
              latlngs: arreglo,
              color: geocerca.color,
            }
            const popupGeofence = this.contenidoMarkerGeofences(pop);
            circulo = this.$refs.map.renderEntityOnMap(propertiesGeofence, popupGeofence);
            this.listaGeocercas[p] = circulo;
            p++;
          }
        });
        this.$refs.map.nuevoZoom(this.listaGeocercas);
      } else {
        this.$refs.map.removeEntityFromMap(this.listaGeocercas, true);
      }
      this.banderaGeocercas = !this.banderaGeocercas;
    },*/

    verGeocercas() {
      if (!this.geocercas || this.geocercas.length === 0) {
        generalSweetAlert(this.$t('vMonitoreo.msgSinGeocercas'), 'info');
        return;
      }

      // 1. SI ESTÁN PRENDIDAS, LAS QUITAMOS TODAS
      if (this.banderaGeocercas) {
        if (this.listaGeocercas && this.listaGeocercas.length > 0) {
          this.$refs.map.removeEntityFromMap(this.listaGeocercas, true);
          this.listaGeocercas = []; // LIMPIEZA ABSOLUTA
        }
      } else {
        // 2. SI ESTÁN APAGADAS, LAS PINTAMOS
        // Antes de pintar en "TODAS LAS GEOCERCAS", nos aseguramos de que no haya geocercas individuales prendidas
        if (this.geocercaSeleccionada) {
          this.verGeocercaGps(this.geocercaSeleccionada); // Apagamos la individual si existe
        }

        let nuevasGeocercasGlobales = [];

        this.geocercas.forEach(geocerca => {
          const nombres = geocerca.dispositivos.map(device => device.nombre).join(', ');
          let circulo = null;

          // Lógica de Punto
          if (geocerca.locate.type === 'Point') {
            const propertiesGeofence = {
              lat: geocerca.latitud,
              lng: geocerca.longitud,
              radio: geocerca.radio * 1,
              color: geocerca.color,
            };
            geocerca.lblDevice = "<b>" + this.$t('dispositivos') + ":</b> " + nombres;
            const popupGeofence = this.contenidoMarkerGeofences(geocerca);
            circulo = this.$refs.map.renderEntityOnMap(propertiesGeofence, popupGeofence);
            nuevasGeocercasGlobales.push(circulo);
          }

          // Lógica de Polígono
          if (geocerca.locate.type === 'Polygon') {
            let arreglo = geocerca.locate.coordinates[0].map(coord => [coord[1], coord[0]]);
            const pop = {
              nombre: geocerca.nombre,
              lblDevice: "<b>" + this.$t('dispositivos') + ":</b> " + nombres,
              alerta: geocerca.alerta,
            };
            const propertiesGeofence = { latlngs: arreglo, color: geocerca.color };
            const popupGeofence = this.contenidoMarkerGeofences(pop);
            circulo = this.$refs.map.renderEntityOnMap(propertiesGeofence, popupGeofence);
            nuevasGeocercasGlobales.push(circulo);
          }
        });

        this.listaGeocercas = nuevasGeocercasGlobales;
        this.$refs.map.nuevoZoom(this.listaGeocercas);
      }

      this.banderaGeocercas = !this.banderaGeocercas;
    },


    verGeocercaGps(datos) {
      // 1. Si ya estaba seleccionado y le volvieron a dar click (para apagarlo)
      if (datos.select) {
        if (this.listaGeocercas && this.listaGeocercas.length > 0) {
          this.$refs.map.removeEntityFromMap(this.listaGeocercas);
          this.listaGeocercas = []; // IMPORTANTE: Vaciar para no dejar basura
        }
        datos.select = false;
        this.geocercaSeleccionada = null;
        return; // Salimos, ya cumplimos la misión de apagar
      }


      let nodoGps = {
        idGps: null,
        idGeocerca: null,
        arrayGpsLatitud: [],
        arrayGpsLongitud: [],
        geocercaGps: []
      }
      let arrayLongitud = [];
      let radioGeocerca = 0;
      let arrayLatitud = [];
      let p = 0,
        ban = 0;
      let registro = 0;

      if (this.banderaGeocercas) {
        this.verGeocercas();
      }

      const geocercas = this.geocercas.filter(geocerca =>
        geocerca.dispositivos.some(dispositivo => dispositivo.imei === datos.imei));
      if (geocercas.length) {
        if (!datos.select) {
          if (this.geocercaSeleccionada) {
            this.$refs.map.removeEntityFromMap(this.listaGeocercas);
            this.geocercaSeleccionada.select = false;
          }
          nodoGps.idGps = datos.id;
          this.geocercaSeleccionada = datos;
          geocercas.forEach(geocerca => {
            let circulo = null;
            if (geocerca.locate.type === 'Point') {
              nodoGps.arrayGpsLatitud.push(geocerca.latitud);
              nodoGps.arrayGpsLongitud.push(geocerca.longitud);

              arrayLatitud.push(geocerca.latitud);
              arrayLongitud.push(geocerca.longitud);
              radioGeocerca = geocerca.radio;

              const propertiesGeofence = {
                lat: geocerca.latitud,
                lng: geocerca.longitud,
                radio: geocerca.radio * 1,
                color: geocerca.color,
              }
              geocerca.lblDevice = "<b>" + this.$t('Gral.dispositivo') + ":</b> " + datos.nombre;
              const popupGeofence = this.contenidoMarkerGeofences(geocerca);
              circulo = this.$refs.map.renderEntityOnMap(propertiesGeofence, popupGeofence);
              this.listaGeocercas[p] = circulo;
              nodoGps.geocercaGps[p] = this.listaGeocercas[p];
              p++;
            }
            if (geocerca.locate.type === 'Polygon') {
              let arreglo = [];
              let item = geocerca.locate.coordinates[0];
              for (let w = 0; w < item.length; w++) {
                arreglo.push([item[w][1], item[w][0]]);
                arrayLatitud.push(item[w][1]);
                arrayLongitud.push(item[w][0]);
              }
              const pop = {
                nombre: geocerca.nombre,
                lblDevice: "<b>" + this.$t('Gral.dispositivo') + ":</b> " + datos.nombre,
                alerta: geocerca.alerta,
              }

              const propertiesGeofence = {
                latlngs: arreglo,
                color: geocerca.color,
              }
              const popupGeofence = this.contenidoMarkerGeofences(pop);
              circulo = this.$refs.map.renderEntityOnMap(propertiesGeofence, popupGeofence);
              this.listaGeocercas[p] = circulo;
              nodoGps.geocercaGps[p] = this.listaGeocercas[p];
              p++;
            }
          });
          this.arrayGps.push(nodoGps);
          this.$refs.map.nuevoZoom(this.listaGeocercas)
        } else {
          this.$refs.map.removeEntityFromMap(this.listaGeocercas);
        }
        datos.select = !datos.select;
      } else {
        generalSweetAlert(this.$t('vMonitoreo.msgSinGeocercas'), 'info');
      }
    },

    /**
     * Renderiza una entidad en el mapa asignando un icono y una ventana emergente según el caso.
     *
     * @param {Object} data - El objeto de datos que contiene información sobre la entidad.
     * @param {string} source - Determina que tipo de entidad se requiere renderizar en el mapa.
     * @param {boolean} needOpen - Determina si la ventana emergente debe abrirse inmediatamente.
     * @returns {Object} - La entidad de mapa renderizada.
     */
    renderEntityOnMap(data, source, needOpen) {
      const icon = getTypeIcon(data.estado);
      const entityMarker = { latlng: data.latlng, icon: icon };
      const popupMarker = this.createPopup(data, source);
      const entity = this.$refs.map.renderEntityOnMap(entityMarker, popupMarker, needOpen);
      return entity;
    },

    verAlertas(datos) {
      const id = datos.id;

      if (!this.alertasSeleccionadas[id]) {
        const icon = getTypeIcon(datos.tipo);
        const position = { lat: datos.latitud, lng: datos.longitud };
        const markAlert = { latlng: position, icon: icon };
        datos.marker = this.$refs.map.renderEntityOnMap(markAlert, null);
        this.alertaSeleccionada = datos;
        this.$refs.map.focusPositionOnMap(position, 16);
      } else {
        this.$refs.map.removeEntityFromMap(datos, true);
      }

      this.$set(this.alertasSeleccionadas, id, !this.alertasSeleccionadas[id]);
      for (const [key, value] of Object.entries(this.alertasSeleccionadas)) {
        if (!value) {
          this.$delete(this.alertasSeleccionadas, key);
        }
      }
    },

    setTrueSelecAlerta(datos) {
      const datosAlerta = {
        ...datos,
        select: true
      }

      this.actualizarSelectAlerta(datosAlerta)
    },

    setFalseSelecAlerta(datos) {
      const datosAlerta = {
        ...datos,
        select: false
      }

      this.actualizarSelectAlerta(datosAlerta)
    },

    async actualizarSelectAlerta(datos) {
      try {
        const response = await AlertasDataService.updateAlerta({ ...datos }, this.key)
        //this.obtenerAlertas()
        this.obtenerAlertasConPaginado();
      } catch (error) {
        console.error('error', error);
        this.alertSweet('error', this.$t('vMonitoreo.msgErrorPosAlerta'))
      }
    },

    /*async dateFilter(newFilter = this.filterDate, page = this.currentPage) {
      if (!newFilter) {
        this.obtenerAlertasConPaginado()
        return;
      }

      this.filterDate = newFilter;
      this.currentPage = page;

      // 1. Normalizar fecha inicial al inicio del día (00:00:00.000)
      const fechaInicio = new Date(this.filterDate.start);
      fechaInicio.setHours(0, 0, 0, 0);

      // 2. Normalizar fecha final al último milisegundo del día (23:59:59.999)
      const fechaFin = new Date(this.filterDate.end);
      fechaFin.setHours(23, 59, 59, 999);

      const data = {
        //fechaInicial: this.filterDate.start,
        //fechaFinal: this.filterDate.end,
        fechaInicial: fechaInicio.toISOString(), // o formatear a "YYYY-MM-DD 00:00:00"
        fechaFinal: fechaFin.toISOString(),
        page: this.currentPage - 1, // backend espera base 0
        size: this.perPage,
        tipo: this.alertFilter || null,
      };

      console.log("data:: ", data);
      

      try {
        const response = await AlertasDataService.getAllByDatePaginado(data, this.key);
        const result = await Crypto.desencriptar(response.data, this.key);
        console.log("result:: ",result);
        

        this.notifications = [...result.data];
        this.totalPaginadoAlertas = result.total;
        this.totalR = (result.data.length == 0 ? 0 : result.total);

      } catch (error) {
        console.error("Error al cargar alertas:", error);
      }
    },*/

    /**
     * Aplica el filtro por rango de fechas y realiza la consulta paginada al backend.
     * @param {Object} newFilter - Objeto que contiene las fechas seleccionadas { start: 'YYYY-MM-DD', end: 'YYYY-MM-DD' }
     * @param {Number} page - Número de página actual para la paginación 
    */
    async dateFilter(newFilter = this.filterDate, page = this.currentPage) {
      if (!newFilter) {
        this.obtenerAlertasConPaginado();
        return;
      }

      this.filterDate = newFilter;
      this.currentPage = page;

      // Extraer las cadenas limpias "YYYY-MM-DD"
      const startStr = typeof newFilter.start === 'string' ? newFilter.start.split('T')[0] : newFilter.start;
      const endStr = typeof newFilter.end === 'string' ? newFilter.end.split('T')[0] : newFilter.end;

      const data = {
        // Concatenamos directo para garantizar que envíe exactamente el día 20
        fechaInicial: `${startStr}T00:00:00.000Z`,
        fechaFinal: `${endStr}T23:59:59.999Z`,
        page: this.currentPage - 1,
        size: this.perPage,
        tipo: this.alertFilter || null,
      };

      try {
        const response = await AlertasDataService.getAllByDatePaginado(data, this.key);
        const result = await Crypto.desencriptar(response.data, this.key);

        this.notifications = [...result.data];
        this.totalPaginadoAlertas = result.total;
        this.totalR = (result.data.length === 0 ? 0 : result.total);

      } catch (error) {
        console.error("Error al cargar alertas:", error);
      }
    },

    onPageChange(page) {
      this.dateFilter(this.filterDate, page);
    },

    async UpdateUserLocation(isLocating) {
      try {
        await UsersDataService.habilitarUbicacionTiempoReal();
      } catch {
        generalSweetAlert(this.$t('vMonitoreo.msgHabilitarUbicacion'), 'error');
      }
    },

    onFilteredDevices(filteredItems) {
      this.totalRowsDevices = filteredItems;
    },

    onFilteredMarkers(filteredItems) {
      this.totalRowsMarkers = filteredItems
    },

    editarDispositivo(datos) {

      this.$router.push({
        name: "Editar dispositivo",
        params: {
          id: datos.id,
          nombre: datos.nombre,
          contrasena: datos.contrasena,
          modelo: datos.modelo,
          modeloGps: datos.model,
          imei: datos.imei,
          usuarios: datos.usuarios,
          telefono: datos.telefono,
          area: datos.area,
          serial: datos.serial,
          tipo: datos.tipo,
          vistaAnterior: "/monitoreo",
        },
      });
    },
    openModal(datos) {
      if (datos.icono === 0) {
        this.nearbyDevice.id = datos.id;
        this.nearbyDevice.nombre = datos.nombre;
        this.showModal = true;
      } else {
        this.$refs.map.removeEntityFromMap(this.listaPosiRedonda);
        this.listaPosiRedonda = null;
        this.$refs.map.removeEntityFromMap(this.listaGeocercas);
        this.listaGeocercas = [];
        datos.icono = 0;
      }
    },
    // Optimizar codigo
    async calcularDispositivosRedonda() {
      if (this.listaGeocercas) {
        this.$refs.map.removeEntityFromMap(this.listaGeocercas);
      }
      if (this.listaPosiRedonda) {
        this.$refs.map.removeEntityFromMap(this.listaPosiRedonda)
      }
      let radioVal = this.radioSettings.radius;
      let distancia = this.radioSettings.distanceUnit;

      if (distancia !== "Metros.") {
        radioVal = radioVal * 1000;
      }

      const data = {
        idDispositivo: this.nearbyDevice.id,
        radio: radioVal
      }

      try {
        const response = await PosicionesDataService.getDispositivosRedonda(data, this.key);
        this.listaPosiRedonda = await Crypto.desencriptar(response.data, this.key);
        this.pintarRedonda(radioVal);
        this.dispositivosTodos.find(dispositivo => dispositivo.id === this.nearbyDevice.id).icono = 1;
      } catch (error) {
        console.error(error);
      } finally {
        this.$bvModal.hide('nerbyDevicesModal');
      }
    },
    // Optimizar codigo
    pintarRedonda(radius) {
      radius = radius * 1;
      const propertiesGeofence = {
        lat: this.listaPosiRedonda[0].latitud,
        lng: this.listaPosiRedonda[0].longitud,
        radio: radius,
        color: this.listaPosiRedonda.length > 1 ? '#e32626' : '#68e557',
      };
      const circulo = this.$refs.map.renderEntityOnMap(propertiesGeofence, null);
      this.listaGeocercas[0] = circulo;

      // Optimizar el proceso del zoom de acuerdo al tamaño del radio de L.Circle
      if (radius < 40000 && radius >= 20000) { //Si el radio de busqueda esta entre 20 a 40 km
        this.$refs.map.focusPositionOnMap(propertiesGeofence, 10);
      } else {
        if (radius >= 8000) {
          this.$refs.map.focusPositionOnMap(propertiesGeofence, 12);
        } else {
          this.$refs.map.focusPositionOnMap(propertiesGeofence, 15);
        }
      }
      this.pintaPosicionesRedonda();
      // Limpiar el contenido del modal
      this.radioSettings.radius = "";
      this.radioSettings.distanceUnit = null;
    },
    // Optimizar codigo
    pintaPosicionesRedonda() {
      this.listaPosiRedonda = this.listaPosiRedonda.map(this.getDisplayPosicion);
      this.listaPosiRedonda.forEach(posicion => {
        const icon = getTypeIcon(posicion.estado);
        const markDevice = { latlng: posicion.latlng, icon: icon };
        const popupMarker = this.contenidoMarkerRedonda(posicion);
        posicion.marker = this.$refs.map.renderEntityOnMap(markDevice, popupMarker);
      });
    },
    OcultarModalRedonda() {
      this.showModal = false;
      //limpiamos las variables por si se había seleccionado algun valor
      this.radioSettings.radius = "";
      this.radioSettings.distanceUnit = null;
    },

    formatDeviceName(device) {
      return device.nombre.length > 17 ? device.nombre.substring(0, 18) + "..." : device.nombre;
    },
    selectAllRows() {
      let arrayPos = [];
      if (!this.banderaUbicaciones) {
        this.marcadores.forEach(ubicacion => {
          ubicacion.select = true;
          const icon = getTypeIcon('MARKER');
          const position = { lat: ubicacion.latitud, lng: ubicacion.longitud };
          const markDevice = { latlng: position, icon: icon };
          const popupMarker = this.contenidoMarkerUbicaciones(ubicacion)
          ubicacion.marker = this.$refs.map.renderEntityOnMap(markDevice, popupMarker);
          arrayPos.push(ubicacion.marker);
          this.listaMarcadores.push(ubicacion)

          // ✅ Marcar como visible
          this.$set(this.marcadoresSeleccionados, ubicacion.id, true);
        });
        this.$refs.map.nuevoZoom(arrayPos)
      } else {
        //this.$refs.map.removeEntityFromMap(this.listaMarcadores)
        //this.marcadores.forEach(ubicacion => ubicacion.select = false);
        //this.listaMarcadores = [];
        // Desactivar todos
        this.listaMarcadores.forEach(ubicacion => {
          if (ubicacion.marker) {
            this.$refs.map.removeEntityFromMap(ubicacion.marker);
            ubicacion.marker = null;
          }

          ubicacion.select = false;
          this.$set(this.marcadoresSeleccionados, ubicacion.id, false); // ✅ Desmarcar visibilidad
        });

        this.listaMarcadores = [];
      }
      this.banderaUbicaciones = !this.banderaUbicaciones;
    },


    verMarcador(datos) {
      const marcador = this.marcadores.find((marcador) => marcador.id === datos.id);
      const id = datos.id;
      const seleccionado = !!this.marcadoresSeleccionados[id];

      if (this.banderaUbicaciones) {
        if (seleccionado) {
          const indexUbicacion = this.listaMarcadores.findIndex((ubicacion) => ubicacion.id === datos.id);
          this.$refs.map.removeEntityFromMap(marcador);
          if (indexUbicacion !== -1) this.listaMarcadores.splice(indexUbicacion, 1);

          // Eliminar también de arrMarkersUbicaciones
          const indexArrMarker = this.arrMarkersUbicaciones.findIndex(m => m === marcador.marker);
          if (indexArrMarker !== -1) this.arrMarkersUbicaciones.splice(indexArrMarker, 1);

          if (this.listaMarcadores.length === 0) {
            this.banderaUbicaciones = false;
            // No hay más marcadores seleccionados, hacer zoom out
            this.$refs.map.resetZoom(); // <- Asegúrate de tener esta función implementada en tu componente del mapa
          } else {
            // Ajustar zoom a los marcadores restantes
            this.$refs.map.nuevoZoom(this.arrMarkersUbicaciones);
          }
        } else {
          const icon = getTypeIcon("MARKER");
          const position = { lat: marcador.latitud, lng: marcador.longitud };
          const markDevice = { latlng: position, icon: icon };
          const popupMarker = this.contenidoMarkerUbicaciones(marcador);
          marcador.marker = this.$refs.map.renderEntityOnMap(markDevice, popupMarker);
          this.listaMarcadores.push(marcador);
          this.arrMarkersUbicaciones.push(marcador.marker);

          if (this.listaMarcadores.length === 1) {
            this.$refs.map.focusPositionOnMap(position, 16);
          } else {
            this.$refs.map.nuevoZoom(this.arrMarkersUbicaciones);
          }
        }

        this.$set(this.marcadoresSeleccionados, id, !seleccionado);

      } else {
        if (!seleccionado) {
          const icon = getTypeIcon("MARKER");
          const position = { lat: marcador.latitud, lng: marcador.longitud };
          const markDevice = { latlng: position, icon: icon };
          const popupMarker = this.contenidoMarkerUbicaciones(marcador);
          marcador.marker = this.$refs.map.renderEntityOnMap(markDevice, popupMarker);
          this.listaMarcadores.push(marcador);
          this.arrMarkersUbicaciones.push(marcador.marker);

          if (this.listaMarcadores.length === 1) {
            this.$refs.map.focusPositionOnMap(position, 16);
          } else {
            this.$refs.map.nuevoZoom(this.arrMarkersUbicaciones);
          }

          if (this.marcadores.length === this.listaMarcadores.length) {
            this.banderaUbicaciones = true;
          }

        } else {
          this.$refs.map.removeEntityFromMap(marcador, true);

          // También actualizar listas
          const indexUbicacion = this.listaMarcadores.findIndex((ubicacion) => ubicacion.id === datos.id);
          if (indexUbicacion !== -1) this.listaMarcadores.splice(indexUbicacion, 1);
          const indexArrMarker = this.arrMarkersUbicaciones.findIndex(m => m === marcador.marker);
          if (indexArrMarker !== -1) this.arrMarkersUbicaciones.splice(indexArrMarker, 1);

          if (this.listaMarcadores.length === 0) {
            this.$refs.map.resetZoom();
          } else {
            this.$refs.map.nuevoZoom(this.arrMarkersUbicaciones);
          }
        }

        this.$set(this.marcadoresSeleccionados, id, !seleccionado);
      }

      for (const [key, value] of Object.entries(this.marcadoresSeleccionados)) {
        if (!value) {
          this.$delete(this.marcadoresSeleccionados, key);
        }
      }
    },

    agregarMarcador() {
      this.isSidebarAVisible = this.isSidebarBVisible = false;

      this.formMarcador = !this.formMarcador;
      this.options.useMarkLocation = true;
      setTimeout(() => {
        this.$nextTick(() => {
          const formElement = this.$el?.querySelector('.mt-4');
          if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth' });
          } else {
            console.warn('Element with class .mt-4 not found.');
          }
        });
      }, 500);

    },

    async registrarMarcador() {
      if (this.editMarker) {
        try {
          // 1. Guardar cambios y actualizar lista general
          const response = await MarcadoresDataService.update(this.marcador, this.key);
          await this.obtenerMarcadores();

          // 2. LIMPIEZA TOTAL FÍSICA
          // Borramos absolutamente todos los marcadores que están actualmente en el mapa
          if (this.listaMarcadores.length > 0) {
            this.$refs.map.removeEntityFromMap(this.listaMarcadores);
          }

          // Limpiamos también el marcador de edición (naranja)
          if (this.layerMarker) {
            this.$refs.map.removeEntityFromMap(this.layerMarker);
            this.layerMarker = null;
          }

          // 3. Procesar el marcador que acabamos de editar
          const decoded = await Crypto.desencriptar(response.data, this.key);
          const idEditado = decoded.id;

          // 4. RESET DE ARREGLOS DE CONTROL
          // Vaciamos las referencias viejas, pero mantenemos los IDs de lo que estaba "en verde"
          const idsQueEstabanActivos = this.listaMarcadores.map(m => m.id);

          // Aseguramos que el ID que acabamos de editar esté en la lista de "activos"
          if (!idsQueEstabanActivos.includes(idEditado)) {
            idsQueEstabanActivos.push(idEditado);
          }

          // Limpiamos los arrays de visualización para reconstruirlos
          this.listaMarcadores = [];
          this.arrMarkersUbicaciones = [];

          // 5. REPINTADO SELECTIVO
          // Recorremos la nueva lista de marcadores (la que trajo obtenerMarcadores)
          // y pintamos solo los que estaban activos
          this.marcadores.forEach(m => {
            if (idsQueEstabanActivos.includes(m.id)) {
              const icon = getTypeIcon('MARKER');
              const position = { lat: m.latitud, lng: m.longitud };
              const markDevice = { latlng: position, icon: icon };
              const popupMarker = this.contenidoMarkerUbicaciones(m);

              // Pintar de nuevo
              m.marker = this.$refs.map.renderEntityOnMap(markDevice, popupMarker);
              m.select = true;

              // Guardar en las listas de control
              this.listaMarcadores.push(m);
              this.arrMarkersUbicaciones.push(m.marker);

              // Poner el ojito en verde
              this.$set(this.marcadoresSeleccionados, m.id, true);
            }
          });

          // 6. Finalizar UI
          const marcadorEditado = this.marcadores.find(m => m.id === idEditado);
          if (marcadorEditado) {
            this.$refs.map.focusPositionOnMap({ lat: marcadorEditado.latitud, lng: marcadorEditado.longitud }, 16);
          }

          const controlesDibujo = document.querySelectorAll('.leaflet-draw-toolbar, .leaflet-draw-actions');
          controlesDibujo.forEach(el => el.remove());
          this.drawControl = null;
          this.formMarcador = false;
          this.editMarker = false;
          this.marcador = {};

          generalSweetAlert(this.$t('vMonitoreo.msgActUbic'), 'success');
        } catch (error) {
          console.error("Error en el repintado:", error);
        }
      } else {
        try {
          this.validatedUbicacion = true;

          if (!this.nombreState || !this.latitudState || !this.longitudState) {
            generalSweetAlert("Faltan campos.", 'warning');
            this.validatedUbicacion = false;
            return
          }

          const response = await MarcadoresDataService.create(this.marcador, this.key);
          await this.obtenerMarcadores();
          // Agregar acción a la bitacora: Falta Agregar

          // Se elimina control y formulario
          this.options.useMarkLocation = false;
          this.formMarcador = false;
          this.$refs.map.removeEntityFromMap(this.layerMarker);
          this.marcador = {
            nombre: "",
            latitud: null,
            longitud: null,
          };

          // Obtener el objeto de la ubicacion previamente guardado en BD
          const decoded = await Crypto.desencriptar(response.data, this.key);
          const marcador = this.marcadores.find(marcador => marcador.id === decoded.id);

          // Renderizar marcador en mapa
          this.listaMarcadores.push(marcador)

          generalSweetAlert(this.$t('vMonitoreo.msgRegUbic'), 'success');
        } catch (error) {
          console.error(error);
        }
      }
    },
    handleLocationMarker(marker) {
      this.marcador.latitud = marker.lat;
      this.marcador.longitud = marker.lng;
      this.layerMarker = marker.layer;
    },
    editarMarcador(datos) {

      if (!this.editMarker) {
        datos.select = true;
        this.formMarcador = !this.formMarcador;

        Object.assign(this.marcador, {
          latitud: datos.latitud,
          longitud: datos.longitud,
          nombre: datos.nombre,
          id: datos.id,
          usuario: datos.usuario
        });

        const mapaReal = this.$refs.map.map;

        editMarkerOnMap(this, this.marcador, mapaReal);
        this.marcador.id = datos.id;
        this.marcador.usuario = datos.usuario;
      }
      this.editMarker = !this.editMarker;
    },

    cancelarMarcador() {
      this.formMarcador = false;
      this.options.useMarkLocation = false;
      this.marcador = {
        nombre: "",
        latitud: null,
        longitud: null,
      };
      if (this.layerMarker) this.$refs.map.removeEntityFromMap(this.layerMarker);
      const controlesDibujo = document.querySelectorAll('.leaflet-draw-toolbar, .leaflet-draw-actions');
      controlesDibujo.forEach(el => el.remove());
      this.$refs.map.resetZoom();
    },

    async eliminarMarcador(datos) {
      const response = await customizedSweetAlert(this.$t('vMonitoreo.msgElimUbic') + datos.nombre, 'warning');
      if (response) {
        try {
          await MarcadoresDataService.delete(datos.id, this.key);
          this.obtenerMarcadores();
          generalSweetAlert(this.$t('vMonitoreo.msgUbicacionEliminada'), 'success');
        } catch (error) {
          console.error(error);
        }
      }
    },


    // ==== Refactorizar más tarde..... ====
    getDisplayPosicion(posicion) {
      //Opciones de icono
      let estadoPosi = "OFF";
      let options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };
      if (posicion.tipo == "LAC") {
        posicion.tipo = "LBS";
      }
      if (posicion.estatusMovimiento) {
        estadoPosi = posicion.estatusMovimiento;
      }
      return {
        id: posicion.id,
        name:
          posicion.dispositivo == null
            ? "Sin nombre"
            : posicion.dispositivo.nombre,
        dispositivo: posicion.dispositivo.id,
        distancia: posicion.precision,
        description: new Date(posicion.fechaHoraPosicion).toLocaleDateString(
          "es-ES",
          options
        ),
        date_build: "",
        imei:
          posicion.dispositivo == null ? "Sin imei" : posicion.dispositivo.imei,
        latlng: {
          lat: Number.parseFloat(posicion.latitud).toFixed(8),
          lng: Number.parseFloat(posicion.longitud).toFixed(8),
        },
        usuario: "Desconocido",
        velocidad: posicion.velocidad.toFixed(2),
        knots: posicion.knots.toFixed(2),
        estado: estadoPosi,
        marker: null,
        tiempoEstatico: posicion.tiempoEstatico,
        tiempoOffline: posicion.tiempoOffline,
        tipo: posicion.tipo == null ? "GPS" : posicion.tipo,
      };
    },


    createPopup(data, source) {
      let popup = '';
      if (source === 'device') {
        popup = `<b>${data.name}</b><br>
            <b>${this.$t('Gral.latitud')}:</b> ${data.latlng.lat}<br>
            <b>${this.$t('Gral.longitud')}:</b> ${data.latlng.lng}<br>
            <b>${this.$t('Gral.tipo')}:</b> ${data.tipo}<br>
            <b>${this.$t('vMonitoreo.velocidad')}:</b> ${data.velocidad} km/h <br>
            <b>${this.$t('vMonitoreo.nudos')}:</b> ${data.knots} m.p.h <br>
            <b>${this.$t('vMonitoreo.estadia')}:</b> ${this.formatoEstadia(data.tiempoEstatico)}<br>
            <b>${this.$t('vMonitoreo.actualizacion')}:</b> ${data.description} hrs <br>
            <b>${this.$t('vMonitoreo.sinActividad')}:</b> ${this.formatoEstadia(data.tiempoOffline)}`;
        return popup;
      }
      if (source === 'geofence') {
        const radio = data?.radio || 0;
        const radioUnit = radio < 1000
          ? `${radio.toFixed(2)} ${this.$t('vMonitoreo.metros')}`
          : `${(radio / 1000).toFixed(2)} ${this.$t('vMonitoreo.km')}`;
        popup = `<b>${data.name}</b><br>
          `;
        return popup;
      }
    },

    contenidoMarkerGeofences(datos) {
      let radioUnit = '';
      if (datos?.radio) {
        let radio = datos.radio;
        radioUnit = radio / 1000 < 1 ?
          Number.parseFloat(radio).toFixed(2) + " " + this.$t('vMonitoreo.metros') :
          Number.parseFloat(radio / 1000).toFixed(2) + " " + this.$t('vMonitoreo.km');
      }
      return (
        "<b>" + datos.nombre + "</b><br>" +
        datos.lblDevice + "<br>" +
        (datos.latitud ? "<b>" + this.$t('Gral.latitud') + ":</b> " + datos.latitud + "<br>" : '') +
        (datos.longitud ? "<b>" + this.$t('Gral.longitud') + ":</b> " + datos.longitud + "<br>" : '') +
        (datos.radio ? "<b>" + this.$t('Gral.radio') + ":</b> " + radioUnit + "<br>" : '') +
        "<b>" + 'Tipo' + ":</b> " + datos.alerta
      );
    },

    contenidoMarkerRedonda(datos) {
      const isPrincipal = datos.dispositivo === this.nearbyDevice.id;
      const distanciaInfo = isPrincipal
        ? ""
        : `<b>${this.$t('vMonitoreo.popupDistancia', { 0: this.nombreGpd })}:</b> ${datos.distancia.toFixed(2)} ${this.$t('configDispositivos.metros')}<br>`;

      return `
          <b>${datos.name}</b><br>
          ${distanciaInfo}
          <b>${this.$t('Gral.latitud')}:</b> ${datos.latlng.lat}<br>
          <b>${this.$t('Gral.longitud')}:</b> ${datos.latlng.lng}<br>
          <b>${this.$t('Gral.tipo')}:</b> ${datos.tipo}<br>
          <b>${this.$t('vMonitoreo.velocidad')}:</b> ${datos.velocidad} km/h<br>
          <b>Nudos:</b> ${datos.knots} m.p.h<br>
          <b>${this.$t('vMonitoreo.estadia')}:</b> ${this.formatoEstadia(datos.tiempoEstatico)}<br>
          <b>${this.$t('vMonitoreo.actualizacion')}:</b> ${datos.description} hrs.<br>
          <b>${this.$t('vMonitoreo.sinActividad')}:</b> ${this.formatoEstadia(datos.tiempoOffline)}
        `;
    },
    contenidoMarkerUbicaciones(datos) {
      const privilegios = sessionStorage.getItem('idRol') == process.env.VUE_APP_ID_ADMINISTRADOR || sessionStorage.getItem('idRol') == process.env.VUE_APP_ID_MASTER;
      const usuario = privilegios ? ` <b> ${this.$t('Gral.usuario')}: </b>${datos.usuario.matricula}` : '';

      return `
          <b>${datos.nombre}</b><br>
          <b>${this.$t('Gral.latitud')}:</b> ${datos.latitud}<br>
          <b>${this.$t('Gral.longitud')}:</b> ${datos.longitud}<br>
          ${usuario}
        `;
    },



    formatoEstadia(segundos) {
      let segs,
        dias,
        horas,
        min,
        cad = "No aplica";

      segs = segundos;
      if (segs == null || segs <= 60) { // si el tiempo de estadía es menor a un minuto o null, No aplica
        return cad;
      } else {
        cad = "";
      }
      if (segs > 86400) {
        //Días
        dias = Math.floor(segs / 86400);
        segs -= dias * 86400;
        cad += dias + " días ";
      }
      if (segs > 3600) {
        //Horas
        horas = Math.floor(segs / 3600);
        segs -= horas * 3600;
        cad += horas + " horas ";
      }
      if (segs > 60) {
        //Minutos
        min = Math.floor(segs / 60);
        segs -= min * 60;
        cad += min + " minutos ";
      }
      if (segs > 0) {
        //Segundos
        cad += segs + " segundos.";
      }
      return cad;
    },
  },
}
</script>


<style>
.mt-container {
  margin-top: -25px;
}

/* Contenedor del mapa para que sea dinámico */
.map-wrapper-scaling {
  width: 100%;
  height: 65vh;
  /* Ocupa el 65% del alto de la pantalla */
  min-height: 500px;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ddd;
}



@media (max-width: 575px) {
  .mt-button {
    margin-top: -15px;
  }
}

.alertas-width {
  overflow-wrap: break-word;
  word-break: break-all;
  /* fuerza el corte de palabras largas sin espacios */
  white-space: normal;
  /* permite múltiples líneas */
  max-width: 100%;
  /* evita que rebase su contenedor */
}
</style>